import React from 'react';
import { Switch } from './ui/switch';

/**
 * Responsive On/Off Toggle
 * Mobile: Button style [Off] [On]
 * Desktop: Switch toggle style
 * Uses brand blue #2563EB for consistency
 */
const OnOffToggle = ({ value, onChange, className = '', disabled = false }) => {
  return (
    <>
      {/* Mobile: Button Style */}
      <div className={`sm:hidden flex gap-1 bg-white rounded-md p-1 border border-gray-200 ${disabled ? 'opacity-50' : ''} ${className}`}>
        <button
          type="button"
          onClick={() => !disabled && onChange(false)}
          disabled={disabled}
          className={`px-3 py-1.5 text-xs font-medium rounded-md transition-colors ${
            !value 
              ? 'bg-gray-200 text-gray-900' 
              : 'text-gray-600 hover:text-gray-900'
          } ${disabled ? 'cursor-not-allowed' : ''}`}
        >
          Off
        </button>
        <button
          type="button"
          onClick={() => !disabled && onChange(true)}
          disabled={disabled}
          className={`px-3 py-1.5 text-xs font-medium rounded-md transition-colors ${
            value 
              ? 'text-white' 
              : 'text-gray-600 hover:text-gray-900'
          } ${disabled ? 'cursor-not-allowed' : ''}`}
          style={value ? { background: '#2563EB' } : {}}
        >
          On
        </button>
      </div>
      
      {/* Desktop: Switch Style - using flex for proper centering */}
      <div className={`hidden sm:flex items-center justify-center ${className}`}>
        <Switch 
          checked={value} 
          onCheckedChange={onChange}
          disabled={disabled}
        />
      </div>
    </>
  );
};

export default OnOffToggle;
